var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuitArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 12,
    xmlSpace: "preserve",
    id: "circuit_arrow_bottom",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circuit_arrow_bottom-bezier",
    stroke: "none",
    fill: "rgb(0, 0, 0)",
    d: "M 19,3 L 17.59,1.59 13,6.17 13,-10 11,-10 11,6.17 6.41,1.58 5,3 12,10 19,3 Z M 19,3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitArrowBottom);
export default __webpack_public_path__ + "static/media/circuit_arrow_bottom.0f3c028dfd83f2557b9e3228d3f513d2.svg";
export { ForwardRef as ReactComponent };